'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Token Types
var CHILD_COMBINATOR_VALUE = exports.CHILD_COMBINATOR_VALUE = 'child';
var DESCENDANT_COMBINATOR_VALUE = exports.DESCENDANT_COMBINATOR_VALUE = 'descendant';
var ELEMENT_TOKEN = exports.ELEMENT_TOKEN = 'element';
var COMBINATOR_TOKEN = exports.COMBINATOR_TOKEN = 'combinator';

// AST Types
var SELECTOR_SEQUENCE = exports.SELECTOR_SEQUENCE = 'SelectorSequence';
var SELECTOR_EXPRESSION_ROOT = exports.SELECTOR_EXPRESSION_ROOT = 'SelectorExpressionRoot';
var SELECTOR_EXPRESSION_CHILD = exports.SELECTOR_EXPRESSION_CHILD = 'SelectorExpressionChild';
var SELECTOR_EXPRESSION_DESCENDANT = exports.SELECTOR_EXPRESSION_DESCENDANT = 'SelectorExpressionDescendant';
var ELEMENT_LITERAL = exports.ELEMENT_LITERAL = 'ElementLiteral';
var COMBINATOR_LITERAL = exports.COMBINATOR_LITERAL = 'CombinatorLiteral';